import Vue from 'vue'

import { QuestionnaireController } from "../controllers/imp/questionnaire"
import { QuestionnaireSectionController } from "../controllers/imp/questionnaire-section"
import { QuestionnaireQuestionController } from "../controllers/imp/questionnaire-question"
import { WorkflowController } from "../controllers/imp/workflow"
import { DataProviderController } from "../controllers/imp/data-provider"
import { ContentController } from "../controllers/imp/content"
import { ContentSectionController } from "../controllers/imp/content-section"


const controllers = {
    questionnaire: QuestionnaireController,
    questionnaire_section: QuestionnaireSectionController,
    questionnaire_question: QuestionnaireQuestionController,
    workflow: WorkflowController,
    data_provider: DataProviderController,
    content: ContentController,
    content_section: ContentSectionController
}

Vue.use({
    install(vue) {
        Vue.prototype.initialise_controllers = function (vueCtx, cb) {
            for (var controller in controllers) {
                controllers[controller].setApp(vueCtx);
            }

            cb();
        }

        vue.prototype.get_controller = function (name) {
            return controllers[name];
        }
    }
})

